import { Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'to-icon',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconComponent {
  @HostBinding('attr.aria-hidden') ariaHidden = 'true';
  @HostBinding('attr.class') class = 'aa-icon';
  @HostBinding('attr.role') role = 'img';

  private SIZE = 'md';
  private TYPE;

  @Input()
  public get size() {
    return this.SIZE;
  }

  public set size(value: string) {
    const sanitizedSize = value || this.SIZE;

    if (this.class.indexOf(`aa-${this.SIZE}`)) {
      this.class.replace(` aa-${this.SIZE}`, '');
    }

    this.class += ` aa-${sanitizedSize}`;
    this.SIZE = sanitizedSize;
  }

  @Input()
  public get type() {
    return this.TYPE;
  }

  public set type(value: string) {
    const sanitizedType = value || this.TYPE;

    if (this.class.indexOf(`aa-${this.TYPE}`)) {
      this.class.replace(` aa-${this.TYPE}`, '');
    }

    this.class += ` aa-${sanitizedType}`;
    this.TYPE = sanitizedType;
  }

  constructor() { }
}

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [IconComponent],
  exports: [IconComponent]
})
export class IconModule { }
